<template>
  <Modal
    inner-class="a11y-layout-reset overflow-y-scroll rounded"
    size="full"
    @close="closeProductSizeGuide"
  >
    <Skeleton
      v-if="fetching || !sizeGuide"
      class="absolute inset-0"
      :full-width="true"
      type="custom"
    />
    <div v-else class="px-4 md:px-8">
      <div v-for="item in sizeGuide" :key="item._uid">
        <component :is="item.component" :blok="item" />
      </div>
    </div>
  </Modal>
</template>

<script setup lang="ts">
import type { Product } from '@scayle/storefront-nuxt'
import { onMounted } from 'vue'
import type { PropType } from 'vue'
import useProductSizeGuide from '~/composables/useProductSizeGuide'
import useUiState from '~/composables/ui/useUiState'

const props = defineProps({
  product: {
    type: Object as PropType<Product>,
    required: true,
  },
})

const { closeProductSizeGuide } = useUiState()

const { getSizeGuide, sizeGuide, fetching } = useProductSizeGuide(props.product)

onMounted(() => {
  if (!sizeGuide.value && !fetching.value && props.product.categories?.length) {
    getSizeGuide()
  }
})
</script>
